// Modal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import './Modal.css'; // We'll define styles next

const VariantModal = ({ show , onConfirm, onCancel , title , message}) => {
  const { t } = useTranslation();
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>{ title }</h3>
        <p>{message}</p>
        {onConfirm &&
        <div className="modal-buttons">
          <button className="modal-ok" onClick={onConfirm}>{t('common.ok')}</button>
          <button className="modal-cancel" onClick={onCancel}>{t('common.cancel')}</button>
        </div>
    }
      </div>
    </div>
  );
};

export default VariantModal;
